import React, { useEffect } from "react";
import { Container, Spinner } from "react-bootstrap";
import PlotTable from "../component/plotTable";
import PlotMobileCard from "../component/plotMobileCard";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HelmetSeo from "../component/HelmetSeo";

const PlotScreenFree = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => console.log("Plotvalidate inputs ", location.state), [
    location,
  ]);

  return (
    <Container>
      <HelmetSeo
        title="Free Plot Validation | Vasthuparam"
        content="Get a complimentary Vasthu validation for your land or plot, analyzing direction, shape, Vedic astrology and surroundings to assess energy balance."
        name="description"
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/plotvalidatefree"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/plotvalidatefree"
      />

      <center>
        <h4 className="m-2">
          <u>{t("USR.PLT.VAL.PLT.DET.TL")}</u>
        </h4>
      </center>
      {location && location.state ? (
        <>
          <PlotTable data={location.state} />
          <PlotMobileCard data={location.state} />
        </>
      ) : (
        <div className="text-center">
          {" "}
          <Spinner animation="border" variant="danger" />{" "}
        </div>
      )}
    </Container>
  );
};

export default PlotScreenFree;
